import { AccountantAccountingSync } from '../../types'
import request from './request'

export default class AccountingSyncController {
  static getStatus(workspaceId: string): Promise<AccountantAccountingSync> {
    return request(`/api/workspaces/${workspaceId}/accounting_sync`)
  }

  // Returns `{ error }` with a 422 when the workspace has no active accounting integration
  static synchronize(workspaceId: string): Promise<AccountantAccountingSync & { error?: string }> {
    return request(`/api/workspaces/${workspaceId}/accounting_sync`, { method: 'POST' })
  }
}
